import type { SearchTravel } from "front-search-schema/algolia";
import { type InferOutput, picklist } from "valibot";

export const ValueTypeSchema = picklist([
  "durations",
  "themes",
  "rythme",
  "destinations",
  "speakers",
  "budgets",
  "lastMinute",
  "primo",
  "garanti",
  "isFitTemplate",
  "startMonths",
  "brandCustomerTitle",
]);
export type ValueType = InferOutput<typeof ValueTypeSchema>;

export const FixedValueTypeSchema = picklist([
  "destinations",
  "themes",
  "lastMinute",
  "primo",
  "garanti",
  "brandCustomerTitle",
]);
export type FixedValueType = InferOutput<typeof FixedValueTypeSchema>;

export type SelectedValue = {
  type: "destinations" | "speakers" | "themes";
  value: string;
};

export type FixedValue = {
  value: string;
  type: FixedValueType;
  isVisible: boolean;
};

export type Value = {
  value: string;
  type: ValueType;
};

export type ConfigValue = {
  value: string;
  type: "lte" | "gte" | "page" | "sort";
};

export type ProductListValues = {
  travelIds: Array<number>;
  destinations: Array<string>;
  gte: string;
  lte: string | null;
};

type TravelOption = {
  type: "travels";
  value: string;
  count: number;
  travel: SearchTravel;
  url: string;
};

type SpeakerOption = {
  type: "speakers";
  value: string;
  count: number;
};

export const OptionTypeSchema = picklist(["destinations", "speakers", "themes"]);
export type OptionType = InferOutput<typeof OptionTypeSchema>;

export type Option =
  | {
      type: "destinations" | "themes";
      value: string;
      count: number;
    }
  | TravelOption
  | SpeakerOption;
